import { help, expert } from "@limitless/images";
export const getDefaultMarketingCards = () => [{
  id: 1,
  title: "Need more help?",
  imgSrc: help,
  headline: "",
  buttonText: "Ask another question",
  primaryColour: "#ED5755",
  contrastColour: "#1A6794"
}, {
  id: 2,
  title: "Join the Expert Team",
  imgSrc: expert,
  headline: "Become an Expert and earn money by helping people",
  buttonText: "Get started",
  primaryColour: "#0050FF",
  contrastColour: "#1A6794"
}];